import { Controller } from "@hotwired/stimulus"
import { addMonths, format } from "date-fns"

export default class extends Controller {
  static values = {
    frozenUntil: String
  }

  static targets = ["nextInvoiceDate", "frozenUntil"]

  connect() {
    this.updateFrozenUntil()
    if (this.frozenUntilValue) {
      const date = new Date(this.frozenUntilValue)
      this.frozenUntilTarget.value = this.#formatDateValue(date)
    }
  }

  updateFrozenUntil() {
    // Remove all but the first blank option.
    this.frozenUntilTarget.length = 1

    const nextInvoiceDate = this.nextInvoiceDateTarget.value

    if (!nextInvoiceDate) return

    const startDate = new Date(nextInvoiceDate)

    for (let i = 0; i <= 6; i++) {
      const date = addMonths(startDate, i)
      const opt = document.createElement("option")
      opt.value = this.#formatDateValue(date)
      opt.innerHTML = format(date, "MMMM dd, yyyy")
      this.frozenUntilTarget.appendChild(opt)
    }
  }

  #formatDateValue(date) {
    return format(date, "yyyy-MM-dd")
  }
}
